<template>
  <div class="table-responsive">
    <div
      id="zero_config_wrapper"
      class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
    >
      <div class="col-sm-12 col-md-12 mb-4">
        <div class="d-flex justify-content-between align-items-center">
          <p
            class="mb-0 font-14 font-weight-bold"
            style="text-transform: capitalize;"
          >
            {{ $t("alarm") }} {{ $t("history") }}
          </p>
          <div class="d-flex col-gap-1 align-items-center">
            <!-- <form @submit.prevent="onFilter" class="form-inline">
              <div style="margin:1px 3px 1px 3px;" class="form-group">
                <label
                  ><b>{{ $t("start-date") }}:</b>&nbsp;</label
                >
                <input
                  type="date"
                  name="date1"
                  class="form-control"
                  v-model="startdate"
                />
              </div>

              <div style="margin:1px 3px 1px 3px;" class="form-group">
                <label
                  ><b>{{ $t("end-date") }}:</b>&nbsp;</label
                >
                <input
                  type="date"
                  name="date2"
                  class="form-control"
                  v-model="enddate"
                />
              </div>

              <div style="margin:1px 3px 1px 3px;">
                <button type="submit" class="btn btn-primary mr-2">
                  {{ $t("filter") }}
                </button>
              </div>
            </form> -->

            <TableSearch :left="'left:18px'" @handleSearch="handleSearch" />
          </div>
        </div>
      </div>
      <div class="row" style="height: 22rem; overflow: auto;">
        <div class="col-sm-12">
          <table id="zero_config" class="table table-hover">
            <thead class="data-table-bg">
              <tr>
                <th
                  :key="index"
                  v-for="(column, index) in tableColumns"
                  @click="sortBy(column[1])"
                  style="cursor: pointer; text-align: left"
                >
                  {{ column[0] }}
                  <span
                    class="arrow"
                    :class="sortOrders[column[1]] > 0 ? 'asc' : 'dsc'"
                  ></span>
                </th>
              </tr>
            </thead>
            <tbody v-if="this.stats.length !== 0">
              <tr
                :key="index"
                v-for="(data, index) in paginatedData"
                style="cursor: pointer; text-align: left;"
                :class="{
                  'data-table-bg': index % 2 !== 0,
                }"
              >
                <td v-if="data.date">{{ data.date }}</td>
                <td v-else>
                  {{ $t("no-read") }}
                </td>
                <td>{{ data.column2 }}</td>
                <td>{{ data.column3 }}</td>
                <td
                  :class="{ 'text-danger': data.tempStat }"
                  v-if="data.column4"
                >
                  {{ data.column4 }}°C
                </td>
                <!-- <td :class="{ 'text-danger': data.humiStat }"> -->
                <td
                  :class="{ 'text-danger': data.humiStat }"
                  v-if="data.column5"
                >
                  {{ data.column5 }}%
                </td>
                <td
                  :class="{ 'text-danger': data.battStat }"
                  v-if="data.column6"
                >
                  {{ data.column6 }}%
                </td>
                <td :class="{ 'text-danger': data.geoStat }">
                  {{ data.geoStat ? $t("excursion") : $t("no_excur") }}
                </td>
                <td :class="{ 'text-danger': data.poiStat }">
                  {{ data.geoStat ? $t("excursion") : $t("no_excur") }}
                </td>
                <td>
                  <div
                    style="display:flex; justify-content: left"
                    class="align-items-center col-gap-1"
                  >
                    <!-- <div
                      v-if="!data.column1"
                      style="height: 0.8rem; width: 0.8rem; border-radius: 0.4rem"
                      class="bg-secondary"
                    ></div> -->
                    <div
                      v-if="data.column9 === 'critical'"
                      style="height: 0.8rem; width: 0.8rem; border-radius: 0.4rem"
                      class="bg-danger"
                    ></div>
                    <div
                      v-else
                      style="height: 0.8rem; width: 0.8rem; border-radius: 0.4rem"
                      class="bg-success"
                    ></div>

                    <span :style="data.column9 === 'critical' && 'color:red'">
                      {{
                        data.column9 === "critical"
                          ? $t("critical")
                          : $t("stable")
                      }}</span
                    >
                  </div>
                </td>
                <!-- <td v-else>
                  No readings yet
                </td> -->
                <!-- <td v-if="data.date">{{ data.date }}</td>
                <td v-else>
                  No readings yet
                </td> -->
              </tr>
            </tbody>
            <tbody v-else align="center">
              <tr align="center">
                <td colspan="12">
                  {{ $t("no_alm_yet") }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <PaginationNew
        :pageCount="pageCount"
        :data="paginatedData"
        :sizeperpage="sizeperpage"
        :pageNumber="pageNumber"
        :pages="pages"
        @goToLastPage="goToLastPage"
        @nextPage="nextPage"
        @handlePageChange="handlePageChange"
        @goToFirstPage="goToFirstPage"
        @prevPage="prevPage"
        @onchange="onchange"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import tableMixin from "../mixins/tableMixinWithBackend";
import TableSearch from "./TableSearch.vue";
import PaginationNew from "./PaginationNew.vue";

export default {
  name: "Table",
  mixins: [tableMixin],
  props: {
    stats: Array,
    paginationMeta: Object,
  },
  data() {
    return {
      pageNumber: 1,
      sizeperpage: 10,
      maxVisibleButtons: 3,
      searchQuery: "",
      sortKey: "",
      sortOrders: {},
      dataTable: [],
    };
  },
  // created() {
  //   let sortOrders = {};
  //   this.tableColumns.forEach(function(key) {
  //     sortOrders[key[1]] = 1;
  //   });
  //   this.sortOrders = sortOrders;
  // },
  watch: {
    stats: {
      handler: function() {
        this.dataTable = [];
        for (let i = 0; i < this.stats.length; i++) {
          let date = this.stats[i].createdAt;
          date = moment(date).format("MMM Do YYYY, hh:mm a");
          this.dataTable.push({
            date: date,
            column3: this.stats[i]?.deviceDetails?.imei,
            column2: this.stats[i]?.deviceStat?.deviceSettings?.name,
            column4: this.stats[i]?.deviceStat?.temperature,
            column5: this.stats[i]?.deviceStat?.humidity,
            column6: this.stats[i]?.deviceStat?.battery,
            column7: this.stats[i]?.geofence?.value,
            column8: this.stats[i]?.pointOfInterest?.value,
            column9: this.stats[i]?.status,
            tempStat: this.stats[i]?.temperature?.excursion,
            humiStat: this.stats[i]?.humidity?.excursion,
            battStat: this.stats[i]?.battery?.excursion,
            poiStat: this.stats[i]?.pointOfInterest?.excursion,
            geoStat: this.stats[i]?.geofence?.excursion,
          });
        }
      },
      deep: true,
    },
  },
  computed: {
    tableColumns() {
      return [
        [this.$t("date_time"), "date"],
        [this.$t("dev-name"), "column2"],
        [this.$t("dev_imei"), "column3"],
        [this.$t("temperature"), "column4"],
        [this.$t("humidity"), "column5"],
        [this.$t("battery"), "column6"],
        [this.$t("geofence"), "column7"],
        [this.$t("POI"), "column8"],
        [this.$t("status"), "column9"],
      ];
    },
  },
  methods: {
    valueUnit(val, title) {
      if (title == "Battery") {
        return val + "%";
      } else if (title == "Humidity" || title == "Temperature") {
        return val + "°C";
      } else return val;
    },
    onFilter() {
      this.mssg = "";
      if (this.startdate && this.enddate) {
        this.isLoading = true;
        let period = {
          start: `${this.startdate.replace(/-/g, "/")} ${this.starttime}`,
          end: `${this.enddate.replace(/-/g, "/")} ${this.endtime}`,
        };
        this.initialiseReport(period);
      } else {
        this.mssg = "Please select a period to view";
      }
    },
  },
  components: { TableSearch, PaginationNew },
};
</script>

<style scoped>
/* td {
  border-bottom: 1px rgba(0, 0, 0, 0.1) solid;
} */

th,
td {
  min-width: 150px;
}
th.active {
  color: #fff;
}

th.active .arrow {
  opacity: 1;
}

.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 8px solid #000000;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 8px solid #000000;
}
</style>

<i18n>
{
	"en": {
		"Search": "Search",
		"alm_type": "Alarm Type",
		"alm_val": "Alarm Value",
		"batt": "Battery {name}",
		"comment": "Comment",
		"date_time": "Date/Time",
		"dev-name": "Device Name",
		"dev-tag": "Device Tag",
		"dev_imei": "Device IMEI",
		"entries": "entries",
		"last-seen": "Last Seen",
		"next": "Next",
		"no-dev": "You have no devices yet",
		"no-read": "No readings yet",
		"no-search": "No search result found",
		"no_alm_yet": "You have no alarm yet",
		"of": "of",
		"prev": "Previous",
		"readings": "readings",
		"show": "Show",
		"showing": "Showing",
		"stat": "Status",
		"to": "to"
	},
	"es": {
		"Search": "Buscar",
		"alm_type": "Tipo de alarma",
		"alm_val": "Valor de alarma",
		"batt": "Batería {name}",
		"comment": "Comentario",
		"date_time": "Fecha y hora",
		"dev-name": "Nombre del dispositivo",
		"dev-tag": "Etiqueta de dispositivo",
		"dev_imei": "IMEI del dispositivo",
		"entries": "entradas",
		"last-seen": "Ultima vez visto",
		"next": "Siguiente",
		"no-dev": "Aún no tienes dispositivos",
		"no-read": "Aún no hay lecturas",
		"no-search": "No se encontraron resultados de búsqueda",
		"no_alm_yet": "Todavía no tienes alarma",
		"of": "de",
		"prev": "Anterior",
		"readings": "Lecturas",
		"show": "Show",
		"showing": "Demostración",
		"stat": "Estado",
		"to": "a"
	},
	"fr": {
		"Search": "Chercher",
		"alm_type": "Type d'alarme",
		"alm_val": "VALEUR D'ALARME",
		"batt": "Batterie {name}",
		"comment": "Commentaire",
		"date_time": "Date / heure",
		"dev-name": "Nom de l'appareil",
		"dev-tag": "Balise d'appareil",
		"dev_imei": "IMEI de l'appareil",
		"entries": "Les entrées",
		"last-seen": "Vue la dernière fois",
		"next": "Suivant",
		"no-dev": "Vous n'avez pas encore d'appareils",
		"no-read": "Pas encore de lectures",
		"no-search": "Aucun résultat de recherche trouvé",
		"no_alm_yet": "Vous n'avez pas encore d'alarme",
		"of": "De",
		"prev": "précédent",
		"readings": "Lectures",
		"show": "Spectacle",
		"showing": "Montrant",
		"stat": "Statut",
		"to": "à"
	},
	"sw": {
		"Search": "Tafuta",
		"alm_type": "Aina ya Kengele",
		"alm_val": "Thamani ya Kengele",
		"batt": "Betri {name}",
		"comment": "Maoni",
		"date_time": "Tarehe/Saa",
		"dev-name": "Jina la kifaa",
		"dev-tag": "Lebo ya Kifaa",
		"dev_imei": "IMEI ya kifaa",
		"entries": "Viingilio",
		"last-seen": "Mara ya mwisho kuonekana",
		"next": "Ifuatayo",
		"no-dev": "Bado huna vifaa",
		"no-read": "Bado hakuna masomo",
		"no-search": "Hakuna matokeo ya utafutaji yaliyopatikana",
		"no_alm_yet": "Bado huna kengele",
		"of": "ya",
		"prev": "Hapo awali",
		"readings": "usomaji",
		"show": "Onyesha",
		"showing": "Kuonesha",
		"stat": "Hali",
		"to": "Kwa"
	}
}
</i18n>
